import { combineReducers } from "redux";

import fetching from "./_fetching";

export default combineReducers({ fetching });
